/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegionDto } from '../../models/region-dto';
import { RegionShowResponse } from '../../models/region-show-response';

export interface PostRegionCreate$Params {
      body: RegionDto
}

export function postRegionCreate(http: HttpClient, rootUrl: string, params: PostRegionCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<RegionShowResponse>> {
  const rb = new RequestBuilder(rootUrl, postRegionCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RegionShowResponse>;
    })
  );
}

postRegionCreate.PATH = '/v1/region';
